export const getProcessStatementCount = (state) =>
    state.processStatement.processStatements.maxCount;